module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp2_6000.64079b75.png";